import axios from "axios";

/**
 * Authentification basée sur cookie httpOnly :
 * - login   → le back set un cookie httpOnly, on stocke en localStorage uniquement
 *             les infos non-sensibles (username, role, etc.) pour l'affichage.
 * - logout  → le back blackliste le token + clear le cookie.
 * - getCurrentUser → lit localStorage en sync (rapide pour l'UI).
 *             En cas de doute (cookie effacé / expiré), un appel /me valide
 *             réellement la session côté serveur.
 */

const API = process.env.REACT_APP_API_URL;
const STORAGE_KEY = "user";

class AuthService {
  async login(username, password) {
    const { data } = await axios.post(API + "login", { username, password });
    // Le token est dans un cookie httpOnly géré par le navigateur — on stocke
    // ici uniquement les infos d'affichage (non sensibles).
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    return data;
  }

  async logout() {
    try {
      await axios.post(API + "logout");
    } catch (e) {
      // best-effort : le cookie expirera côté back de toute façon
    }
    localStorage.removeItem(STORAGE_KEY);
  }

  /**
   * Lecture synchrone des infos user (pour l'UI).
   * Ne valide PAS la session côté serveur — utiliser checkSession() pour ça.
   */
  getCurrentUser() {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  /**
   * Validation réelle de la session via le back.
   * Retourne le user si le cookie est valide, null sinon (et nettoie localStorage).
   */
  async checkSession() {
    try {
      const { data } = await axios.get(API + "me");
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      return data;
    } catch (e) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  }
}

export default new AuthService();
